import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignBlocksRightSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1h1v10h-1V1zM9 3H1v2h8V3zm0 4H4v2h5V7z"
    />
  </svg>
);
export default IconAlignBlocksRightSizeXs;
